import * as React from "react";

import { cn } from "@/lib/utils";
import { Label } from "./label";
import { ChangeEvent } from "react";

function Input({
  className,
  type,
  label,
  guide,
  onChange,
  required = false,
  error = false,
  onEnter,
  ...props
}: Omit<React.ComponentProps<"input">, "onChange"> & {
  label?: string;
  guide?: string;
  error?: boolean;
  onChange?: (e: string) => void;
  onEnter?: () => void;
}) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      const value = e.target.value;
      onChange(value);
    }
  };

  const handleEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (onEnter) onEnter();
    }
  };

  return (
    <div className="flex flex-col gap-1 w-full">
      {label && (
        <Label className="text-14m text-gray-600 flex gap-0.5">
          {label}
          {required && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="4"
              height="20"
              viewBox="0 0 4 20"
              fill="none"
              className="mt-0.5"
            >
              <circle cx="2" cy="5" r="2" fill="#F97316" />
            </svg>
          )}
        </Label>
      )}
      <input
        type={type}
        data-slot="input"
        className={cn(
          `rounded-[10px] border border-gray-200 px-3 py-[9px] hover:py-[8px] hover:px-[11px] placeholder:text-gray-400 text-15r transition-colors duration-200 disabled:bg-gray-100 outline-blue-400 hover:border-2 hover:border-blue-200 ${
            error ? "border-2 border-red-500" : ""
          }`,
          className
        )}
        onChange={handleChange}
        onKeyDown={handleEnter}
        {...props}
      />
      {guide && (
        <Label
          className={`text-14r ${error ? "text-red-500" : "text-gray-500"}`}
        >
          {guide}
        </Label>
      )}
    </div>
  );
}

export { Input };
